import { supabase } from "../lib/supabase";

export interface QrSessionRow {
  id: string;
  session_token: string;
  user_id: string | null;
  expires_at: string;
  is_used: boolean;
  logout_requested: boolean;
  logout_timestamp: string | null;
  auth_access_token: string | null;
  auth_refresh_token: string | null;
  created_at: string;
}

export interface CreateQrSessionOptions {
  token: string;
  expiresAt: string;
  authAccessToken?: string;
  authRefreshToken?: string;
}

/**
 * @description QR 세션을 생성한다. 로그인 상태일 경우 auth 토큰을 함께 저장해 모바일 자동 로그인을 지원한다.
 */
export async function createQrSession(
  token: string,
  expiresAt: string,
  authAccessToken?: string,
  authRefreshToken?: string,
): Promise<void> {
  const { error } = await supabase
    .from("qr_sessions")
    .insert({
      session_token: token,
      expires_at: expiresAt,
      is_used: false,
      auth_access_token: authAccessToken ?? null,
      auth_refresh_token: authRefreshToken ?? null,
    });

  if (error) throw error;
}

/**
 * @description 세션 토큰으로 QR 세션을 조회한다.
 */
export async function findQrSession(
  token: string,
): Promise<QrSessionRow | null> {
  const { data, error } = await supabase
    .from("qr_sessions")
    .select("*")
    .eq("session_token", token)
    .maybeSingle();

  if (error) throw error;
  return data as QrSessionRow | null;
}

/**
 * @description QR 세션을 사용 완료 처리한다.
 */
export async function markQrSessionUsed(
  token: string,
  userId: string,
): Promise<void> {
  const { error } = await supabase
    .from("qr_sessions")
    .update({ user_id: userId, is_used: true })
    .eq("session_token", token);

  if (error) throw error;
}
